// Curash dedicated reviews page — generates a very large set of UNIQUE reviews
// (no looping/recycling). Each card at index N is deterministically assembled
// from phrase banks (name + rating + title + body built from parts), so card N
// is always the same card N, every card is distinct, and it never repeats until
// the combinatorial space is exhausted (millions of combos). Infinite scroll.
(function () {
  'use strict';

  // ---- Building blocks ----------------------------------------------------
  var FIRST = ['Sofia', 'Amara', 'Emily', 'Priya', 'Jade', 'Hannah', 'Olivia', 'Mei', 'Grace', 'Layla',
    'Isabel', 'Chloe', 'Nadia', 'Rachel', 'Tara', 'Bianca', 'Sara', 'Maya', 'Lucia', 'Aisha',
    'Daniela', 'Freya', 'Noor', 'Camila', 'Zoe', 'Ines', 'Yara', 'Leah', 'Marta', 'Selin',
    'Paula', 'Hana', 'Renee', 'Alina', 'Bella', 'Carmen', 'Dina', 'Esra', 'Farah', 'Gina',
    'Halle', 'Iris', 'Jana', 'Kira', 'Lena', 'Nina', 'Oksana', 'Petra', 'Rosa', 'Sana',
    'Talia', 'Uma', 'Vera', 'Wendy', 'Yana', 'Zara', 'Amelia', 'Bridget', 'Cara', 'Elena',
    'Fiona', 'Gemma', 'Heidi', 'Ivy', 'Jess', 'Kayla', 'Lottie', 'Mira', 'Nora', 'Orla',
    'Pia', 'Rhea', 'Sela', 'Tess', 'Vida', 'Willa', 'Yvette', 'Anya', 'Beatriz', 'Cleo',
    'Demi', 'Effie', 'Fleur', 'Greta', 'Hilda', 'Ida', 'Juno', 'Kaia', 'Lia', 'Mila',
    'Naomi', 'Olga', 'Pearl', 'Quinn', 'Rina', 'Suki', 'Thea', 'Ula', 'Vanya', 'Wren',
    'Adira', 'Birdie', 'Coco', 'Dahlia', 'Edie', 'Faye', 'Gia', 'Hattie', 'Joy', 'Liv',
    'Maeve', 'Nell', 'Opal', 'Posy', 'Romy', 'Sky', 'Tilly', 'Vivi', 'Xara', 'Zinnia'];
  var LAST = ['R.', 'K.', 'T.', 'S.', 'M.', 'L.', 'B.', 'C.', 'W.', 'F.', 'N.', 'D.', 'H.', 'P.', 'V.',
    'A.', 'J.', 'G.'];

  var TITLES = [
    'Snatched in all the right places', 'Worth every penny', 'Confidence in a piece',
    'Finally something that stays put', 'My new everyday', 'Sculpts without squeezing',
    'Premium feel', 'Invisible under everything', 'Better than the big brands',
    'Holds everything in', 'Game changer', 'Stays in place', 'Obsessed', 'Premium all the way',
    'Best purchase this year', 'Feels like nothing', 'Smooth and seamless', 'Quality you can feel',
    'Stunning silhouette', 'So comfortable', 'Worth the hype', 'Flawless under fabric',
    'Beautifully made', 'My confidence booster', 'Cannot fault it', 'Sleek and supportive',
    'Exceeded expectations', 'Total transformation', 'Sculpted perfection', 'My secret weapon',
    'Effortless shape', 'Premium done right', 'My go-to under everything', 'Holds the shape',
    'Adore the shape', 'Worth the investment', 'My everyday luxury', 'Just perfect',
    'Smooth as silk', 'Could not be happier'];

  // Body = opener + middle + closer. Each part is a full clause; combine for variety.
  var OPENERS = [
    'Honestly the best shapewear I have owned.', 'The fabric feels genuinely luxe, not cheap and squeezy.',
    'Skeptical at first but it completely won me over.', 'I put off ordering for ages and wish I had not.',
    'Tried the famous brands and this beats them.', 'I do not usually spend this much and I am so glad I did.',
    'Put it on and immediately ordered another.', 'Exactly what premium shapewear should be.',
    'It has quietly become part of my everyday routine.', 'The difference under my clothes is unreal.',
    'I expected to suffer for the shape and instead it is the comfiest thing I own.',
    'From the packaging to the fabric, it feels high end.', 'My silhouette under dresses is so much smoother now.',
    'I keep recommending it to everyone who asks.', 'Better quality than I expected for the price.',
    'On my third one now and the fit never disappoints.', 'It does exactly what it promises.',
    'I felt so put together the moment I had it on.', 'This little piece does a lot of work.',
    'My favourite buy of the year, no question.'];
  var MIDDLES = [
    'It smooths everything and you forget you are wearing it.', 'Held me in through a long event with zero rolling.',
    'The seams are invisible under everything and it never digs in.', 'Supportive without ever cutting in or pinching.',
    'No more constant adjusting all day.', 'Firm where I need it, soft where I do not.',
    'Gives a natural hourglass line, not a squeezed one.', 'Breathable enough that I could eat and move freely.',
    'No VPL, no lines, nothing — like a second skin.', 'The waist control is exactly what I was after.',
    'Holds up wash after wash with no stretching or pilling.', 'Stayed exactly where it should from morning to night.',
    'Smooth from every angle, even under clingy fabric.', 'The shaping looks completely natural.',
    'Comfortable enough to live in and flattering too.', 'Defined my waist beautifully without crushing me.',
    'The finishing details are lovely and clearly premium.', 'Soft on the skin yet seriously supportive.'];
  var CLOSERS = [
    'Buying more in every colour.', 'Absolutely worth it.', 'Highly recommend.', 'Will not go back to the cheap ones.',
    'Cannot recommend it enough.', 'My new go-to under everything.', 'So glad I finally ordered.',
    'It elevates every outfit.', 'Obsessed, honestly.', 'Five stars all day.', 'Worth every penny.',
    'Already eyeing a second.', 'A genuine wardrobe essential.', 'I feel amazing in it.', 'No notes.',
    'Exactly what I hoped for.', 'Quietly does so much.', 'I look forward to getting dressed now.'];

  // 4★ and 3★ get a small caveat appended so the rating reads authentically.
  var CAVEAT_4 = [
    ' Knocked one star only because I wanted it a touch longer.',
    ' Sizing runs slightly small, so size up.',
    ' Would love it in more colours.', ' A softer waistband would make it perfect.',
    ' Took a couple of wears to mould to me, then ideal.'];
  var CAVEAT_3 = [
    ' Lovely quality but it runs small — size up and it would be five stars.',
    ' Good shaping, though the band is a little firm for me.',
    ' Nice piece overall, just wished it came in petite.',
    ' Does the job but took some getting used to.'];

  // Full bodies for the rare lower ratings (fair, not exaggerated). Large enough
  // that the capped counts (2★ = 8, 1★ = 23) never repeat a body.
  var BODY_2 = [
    'The quality is nice but the sizing was off for me — I had to return for a larger size and it took a while.',
    'Comfortable fabric, but it rolled down on me through the day. Might just be my shape.',
    'Decent shaping but the delivery took longer than expected. The product itself is okay.',
    'Not bad, though it felt tighter than I hoped around the waist. Lovely material otherwise.',
    'The fabric is lovely but the fit was not quite right for me. Exchange was straightforward at least.',
    'Good idea and nice quality, but it did not stay in place the way I wanted.',
    'It is well made, just a little firm around the middle for my taste.',
    'Pretty piece but I found the straps slightly tight. The body of it is comfortable though.',
    'Material feels premium, but the length was off for my height.',
    'Okay overall. Smooths nicely but the waistband was firmer than I expected.'];
  var BODY_1 = [
    'Unfortunately the size I ordered did not fit and the exchange process was slower than I would have liked.',
    'The fabric is nice but it was not the right shape for me. Returned it without much trouble though.',
    'Did not work for my body type. Customer service was polite but it just was not for me.',
    'Sadly the sizing ran small and the one I swapped to still was not right.',
    'Lovely material but it did not suit my figure. A miss for me personally.',
    'Not the fit I hoped for. The quality is there, it just was not for me.',
    'It rolled down throughout the day and I could not get comfortable in it.',
    'The shade was different to what I expected and the fit was a little off.',
    'Returned this one — the waist was too tight even after sizing up.',
    'Nice packaging and fabric, but the cut did not flatter me the way I wanted.',
    'Took longer to arrive than expected and then the size was not right.',
    'I wanted to love it but it just did not sit well on my shape.',
    'The support was there but it felt restrictive rather than comfortable.',
    'Good quality fabric, wrong fit for me. Exchange sorted it but it took time.',
    'Not my favourite. It looked great but was not comfortable for all-day wear.',
    'The length was off for me and it bunched a little at the waist.',
    'Lovely to look at, but I found it tight in the wrong places.',
    'It was not the right piece for my body type, though the material is nice.',
    'Sizing guide put me between sizes and neither was quite right.',
    'Comfortable fabric but it did not hold its shape as I had hoped.',
    'A little disappointed with the fit, though customer service was helpful.',
    'Not as flattering on me as I expected from the photos.',
    'The fit just was not for me — returned without any issues though.',
    'Material is soft but the shaping was firmer than I find comfortable.',
    'Did not stay in place for me. Might suit a different shape better.'];

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // ---- Deterministic hashing so card N is stable & unique -----------------
  function hash(n) {
    n = (n ^ 0x9e3779b9) >>> 0;
    n = Math.imul(n ^ (n >>> 16), 0x21f0aaad) >>> 0;
    n = Math.imul(n ^ (n >>> 15), 0x735a2d97) >>> 0;
    return (n ^ (n >>> 15)) >>> 0;
  }
  function pick(arr, n, salt) { return arr[hash(n * 2654435761 + salt) % arr.length]; }

  // Rating distribution: mostly 5, some 4, few 3, and a rare 2/1 so those
  // filters still surface real cards (matching the low headline counts).
  function ratingFor(n) {
    var v = hash(n + 777) % 1000;
    if (v < 840) return 5;
    if (v < 958) return 4;
    if (v < 985) return 3;
    if (v < 994) return 2;
    return 1;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function nameFor(n) {
    return pick(FIRST, n, 11) + ' ' + pick(LAST, n, 23);
  }
  // Titles are built combinatorially (adjective + noun) so they are unique per
  // card across hundreds of combinations, the same way bodies are.
  var T_ADJ = ['Absolutely', 'Genuinely', 'Seriously', 'Effortlessly', 'Beautifully', 'Surprisingly',
    'Honestly', 'Quietly', 'Properly', 'Truly', 'Wonderfully', 'Pleasantly'];
  var T_NOUN = ['flawless', 'flattering', 'comfortable', 'supportive', 'worth it', 'impressed',
    'snatched', 'smooth', 'in love', 'obsessed', 'premium', 'confident', 'sculpted', 'won over',
    'a wardrobe staple', 'better than expected'];
  function comboTitle(n, adjArr, nounArr) {
    // True mixed-radix bijection over the A×B combo space: scramble the card
    // index by a multiplier co-prime with A*B, then decompose into (adj, noun)
    // coordinates. This visits every combination exactly once AND advances BOTH
    // the adjective and the noun on every single card, so neighbouring reviews
    // never share a word (previously the noun only changed every A cards, so a
    // word like "flawless" appeared in ~12 consecutive headings — looked fake).
    var A = adjArr.length, B = nounArr.length, SPACE = A * B;
    var idx = (n * 13) % SPACE;      // 13 is co-prime with 12*16=192 → bijection
    var ai = idx % A;
    var bi = Math.floor(idx / A) % B;
    var s = adjArr[ai] + ' ' + nounArr[bi];
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Low-rating titles: a flat list of distinct, grammatical titles. The low
  // ratings are few (23 + 8) so we index them by their sequence position (not
  // the scattered card index) to guarantee no two repeat.
  var TITLES_LOW = [
    'Not quite right for me', 'Sizing was off', 'Wanted to love it', 'Mixed feelings',
    'Not my fit', 'Okay, but not for me', 'A tough fit', 'Not as I hoped',
    'Lovely fabric, wrong size', 'Just not for my shape', 'Returned this one',
    'Close, but not quite', 'Ran small for me', 'Comfortable but rolled down',
    'Nice quality, off sizing', 'Did not suit me', 'Hoped for more',
    'Not the right shape', 'A little disappointed', 'Fabric good, fit off',
    'Took a while to arrive', 'Snug in the wrong way', 'Not what I expected',
    'Better luck needed on size', 'Material nice, fit not', 'Slightly too tight',
    'Just missed the mark', 'Lovely but not for me', 'Sizing let it down',
    'Could not get the fit', 'Not my favourite'];

  // Bijective mixed-radix mapping: a single scrambled index is decomposed into
  // independent (opener, middle, closer) coordinates, so each card gets a UNIQUE
  // triple. No two cards share the same body until the full 20×18×18 = 6,480
  // combination space is exhausted. A large odd multiplier scrambles the index so
  // neighbouring cards never share an opener (which is what looked "repeated").
  var O = OPENERS.length, M = MIDDLES.length, C = CLOSERS.length;
  var SPACE = O * M * C; // 6480 distinct bodies
  // True bijection: map n -> a unique point in the O×M×C grid with NO collisions
  // for the first SPACE indices. We advance each coordinate by a stride that is
  // co-prime with its size so neighbouring cards never share the same opener,
  // while every (opener,middle,closer) triple is still hit exactly once.
  function bodyParts(n) {
    var idx = n % SPACE;                 // unique slot in [0, SPACE)
    var oi = (idx * 7) % O;              // 7 co-prime with 20
    var mi = (Math.floor(idx / O) * 5) % M; // 5 co-prime with 18
    var ci = (Math.floor(idx / (O * M)) * 7) % C; // 7 co-prime with 18
    return OPENERS[oi] + ' ' + MIDDLES[mi] + ' ' + CLOSERS[ci];
  }

  // For low ratings we pass a sequence rank (0,1,2…) so each of the few low cards
  // gets a distinct title/body from the flat lists (no repeats). 2★ uses the
  // first slice of titles, 1★ uses a non-overlapping later slice so the two
  // rating groups never share a heading.
  function titleFor(n, r, rank) {
    if (r === 2) return TITLES_LOW[rank % TITLES_LOW.length];
    if (r === 1) return TITLES_LOW[(rank + 8) % TITLES_LOW.length];
    return comboTitle(n, T_ADJ, T_NOUN);
  }
  function bodyFor(n, r, rank) {
    if (r === 2) return BODY_2[rank % BODY_2.length];
    if (r === 1) return BODY_1[rank % BODY_1.length];
    var b = bodyParts(n);
    if (r === 4) b += pick(CAVEAT_4, n, 71);
    else if (r === 3) b += pick(CAVEAT_3, n, 73);
    return b;
  }
  function dateFor(n, r) {
    var rng = hash(n + 12345);
    var d;
    if (r <= 2) {
      // 1★ and 2★ reviews are always dated within 2025 (spread across the year).
      var doy = rng % 365;               // day of year 0..364
      d = new Date(Date.UTC(2025, 0, 1 + doy));
    } else {
      d = new Date(Date.now() - (3 + (rng % 360)) * 86400000);
    }
    return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
  }

  function starsHtml(r, cls) {
    // Render filled vs empty stars as literal characters — no overlay/clip trick,
    // so the count is always exactly right regardless of CSS.
    r = Math.max(0, Math.min(5, Math.round(r)));
    var filled = '', empty = '';
    for (var i = 0; i < r; i++) filled += '★';
    for (var j = 0; j < 5 - r; j++) empty += '★';
    return '<span class="' + cls + '" aria-label="' + r + ' out of 5">'
      + '<span class="crp-stars-on" aria-hidden="true">' + filled + '</span>'
      + '<span class="crp-stars-off" aria-hidden="true">' + empty + '</span>'
      + '</span>';
  }

  // Lazily build a map from a low-rating card's global index -> its sequence rank
  // among cards of that rating, so each gets a distinct title/body.
  var LOW_RANK = null;
  function buildLowRanks() {
    LOW_RANK = {};
    var c1 = 0, c2 = 0;
    for (var n = 0; n < 20000; n++) {
      var r = ratingFor(n);
      if (r === 1) { LOW_RANK[n] = c1++; }
      else if (r === 2) { LOW_RANK[n] = c2++; }
    }
  }

  // Build the review object for global index n.
  function reviewAt(n) {
    var r = ratingFor(n);
    var rank = 0;
    if (r <= 2) {
      if (!LOW_RANK) buildLowRanks();
      rank = LOW_RANK[n] || 0;
    }
    return { n: nameFor(n), r: r, t: titleFor(n, r, rank), b: bodyFor(n, r, rank) };
  }

  function cardHtml(rev, n) {
    var initial = rev.n.charAt(0).toUpperCase();
    return '<article class="crp-card">'
      + '<div class="crp-card-top">'
      + '<span class="crp-avatar" aria-hidden="true">' + initial + '</span>'
      + '<div class="crp-card-meta">'
      + '<span class="crp-card-name">' + escapeHtml(rev.n) + '</span>'
      + '<span class="crp-verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>Verified Purchase</span>'
      + '</div>'
      + '<span class="crp-card-date">' + dateFor(n, rev.r) + '</span>'
      + '</div>'
      + starsHtml(rev.r, 'crp-card-stars')
      + '<h3 class="crp-card-title">' + escapeHtml(rev.t) + '</h3>'
      + '<p class="crp-card-body">' + escapeHtml(rev.b) + '</p>'
      + '</article>';
  }

  function init(root) {
    if (root.dataset.crpWired === '1') return;
    root.dataset.crpWired = '1';

    var grid = root.querySelector('[data-crp-grid]');
    var moreBtn = root.querySelector('[data-crp-more]');
    var sentinel = root.querySelector('[data-crp-sentinel]');
    var filterWrap = root.querySelector('[data-crp-filters]');
    var summary = root.querySelector('[data-crp-total-count]');
    if (!grid) return;

    var PAGE = 24;     // cards per batch
    var MAX = 20000;   // unique cards available before we stop (no looping)
    var filter = 0;    // 0 = all, else star value
    var cursor = 0;    // next global index to render
    var emitted = 0;

    // ---- Summary header (configurable big total) ----
    var totalCount = parseInt(summary && summary.getAttribute('data-crp-total-count'), 10);
    if (!totalCount || totalCount < 1) totalCount = 20000;
    var avgRating = parseFloat(summary && summary.getAttribute('data-crp-avg-rating')) || 4.8;

    // Believable star breakdown that sums EXACTLY to the headline total.
    // 1★ and 2★ are kept deliberately low (fixed) for trust; 4★/3★ scale with
    // the total; 5★ absorbs the remainder.
    var counts = {
      1: 23,
      2: 8,
      4: Math.round(totalCount * 0.105),
      3: Math.round(totalCount * 0.022)
    };
    counts[5] = totalCount - counts[4] - counts[3] - counts[2] - counts[1];

    var avgEl = root.querySelector('[data-crp-avg]');
    var avgStarsEl = root.querySelector('[data-crp-avg-stars]');
    var totalEl = root.querySelector('[data-crp-total]');
    var badgeTotal = root.querySelector('[data-crp-badge-total]');
    if (avgEl) avgEl.textContent = avgRating.toFixed(2);
    if (avgStarsEl) avgStarsEl.innerHTML = starsHtml(Math.round(avgRating), 'crp-avg-stars');
    if (totalEl) totalEl.textContent = 'Based on ' + totalCount.toLocaleString() + ' reviews';
    if (badgeTotal) {
      badgeTotal.textContent = totalCount >= 1000
        ? (Math.floor(totalCount / 100) / 10).toLocaleString() + 'k+'
        : totalCount.toLocaleString();
    }

    var barsWrap = root.querySelector('[data-crp-bars]');
    if (barsWrap) {
      var bhtml = '';
      [5, 4, 3, 2, 1].forEach(function (star) {
        var pct = Math.round((counts[star] / totalCount) * 100);
        bhtml += '<button type="button" class="crp-bar-row" data-crp-filter="' + star + '">'
          + '<span class="crp-bar-label">' + star + '★</span>'
          + '<span class="crp-bar-track"><span class="crp-bar-fill" style="width:' + pct + '%"></span></span>'
          + '<span class="crp-bar-count">' + counts[star].toLocaleString() + '</span>'
          + '</button>';
      });
      barsWrap.innerHTML = bhtml;
      barsWrap.addEventListener('click', function (e) {
        var row = e.target.closest('[data-crp-filter]');
        if (row) setFilter(parseInt(row.getAttribute('data-crp-filter'), 10));
      });
    }

    // ---- Render next batch (respecting the active rating filter) ----
    function renderMore() {
      // When filtering by a specific rating, cap the visible cards to that
      // rating's headline count so the grid matches the breakdown bar.
      var cap = filter ? counts[filter] : Infinity;
      var html = '';
      var added = 0;
      while (added < PAGE && cursor < MAX && emitted < cap) {
        var rev = reviewAt(cursor);
        if (filter === 0 || rev.r === filter) {
          html += cardHtml(rev, cursor);
          added++;
          emitted++;
        }
        cursor++;
      }
      if (html) grid.insertAdjacentHTML('beforeend', html);
      var done = cursor >= MAX || emitted >= cap;
      if (moreBtn) moreBtn.style.display = done ? 'none' : '';
      if (done && observer) observer.disconnect();
    }

    function setFilter(star) {
      filter = (filter === star) ? 0 : star;
      cursor = 0; emitted = 0;
      grid.innerHTML = '';
      if (filterWrap) {
        filterWrap.querySelectorAll('[data-crp-pill]').forEach(function (p) {
          p.classList.toggle('is-active', parseInt(p.getAttribute('data-crp-pill'), 10) === filter);
        });
      }
      if (moreBtn) moreBtn.style.display = '';
      if (observer && sentinel) observer.observe(sentinel);
      renderMore();
    }

    if (moreBtn) moreBtn.addEventListener('click', renderMore);
    if (filterWrap) filterWrap.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-crp-pill]');
      if (pill) setFilter(parseInt(pill.getAttribute('data-crp-pill'), 10));
    });

    // ---- Infinite scroll ----
    var observer = null;
    if ('IntersectionObserver' in window && sentinel) {
      observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) renderMore();
      }, { rootMargin: '600px 0px' });
      observer.observe(sentinel);
    }

    renderMore();
  }

  // ---- Write-a-review modal -----------------------------------------------
  function initModal() {
    var modal = document.querySelector('[data-crp-modal]');
    if (!modal || modal.dataset.crpWired === '1') return;
    modal.dataset.crpWired = '1';

    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }

    document.querySelectorAll('[data-crp-open-write]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-crp-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    // Star rating picker
    var stars = modal.querySelectorAll('[data-crp-star]');
    var input = modal.querySelector('[data-crp-rating-input]');
    function paint(val) {
      stars.forEach(function (s) {
        s.classList.toggle('is-on', parseInt(s.getAttribute('data-crp-star'), 10) <= val);
      });
    }
    stars.forEach(function (s) {
      var val = parseInt(s.getAttribute('data-crp-star'), 10);
      s.addEventListener('mouseenter', function () { paint(val); });
      s.addEventListener('click', function () { if (input) input.value = val; paint(val); });
    });
    var ratingWrap = modal.querySelector('[data-crp-rate]');
    if (ratingWrap) ratingWrap.addEventListener('mouseleave', function () { paint(input ? parseInt(input.value, 10) : 5); });
    paint(input ? parseInt(input.value, 10) || 5 : 5);

    // Re-open after a successful submit (Shopify reloads the page on contact post)
    if (window.__crpOpenModalOnLoad) open();
  }

  function boot() {
    document.querySelectorAll('[data-curash-reviews-page]').forEach(init);
    initModal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
